var fetchLookups = function(lookups) {
    lookups.forEach(({target, action, cached}) => {
        if(!this[target].length || !cached) {
            this["loading"][target] = true;
            action
                .then(result => {
                    this[target] = result.data;
                    this["loading"][target] = false;
                })
                .catch(() => {
                    fetchLookups(lookups);
                });
        }
    })
}

module.exports = fetchLookups;